import { createSelector } from 'reselect'
import {
  selectIsAcknowledgementAlertBarOpenFromState,
  selectIsAlertBarOpenFromState,
  selectIsDowngradeBarOpenFromState,
} from 'src/redux/selectors/app.selectors'
import {
  selectIsCspAuthenticatedFromState,
  selectUserHasFailScreening,
  selectUserHasForbiddenScreening,
} from 'src/redux/selectors/auth.selectors'

// Reads isCspAuthenticated off the Redux mirror (unchanged) — see src/queries/AGENTS.md for the authStatusStore migration status.
// TODO: refactor this to bannerPushdown or something
export const selectFixedElementPushdown = createSelector(
  [
    selectIsAlertBarOpenFromState,
    selectIsCspAuthenticatedFromState,
    selectUserHasForbiddenScreening,
    selectUserHasFailScreening,
    selectIsDowngradeBarOpenFromState,
    selectIsAcknowledgementAlertBarOpenFromState,
  ],
  (
    isAlertBarOpen,
    isCspAuthenticated,
    userHasForbiddenScreening,
    userHasFailScreening,
    isDowngradeBarOpen,
    userHasNotAcknowledged,
  ) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    if (isAlertBarOpen) {
      pushDown += 40
    }
    if (userHasForbiddenScreening) {
      pushDown += 40
    }
    if (userHasFailScreening) {
      pushDown += 40
    }
    if (isDowngradeBarOpen) {
      pushDown += 40
    }
    // If the user has not acknowledged the alert bar, we add an additional push down
    if (userHasNotAcknowledged) {
      pushDown += 40
    }
    return pushDown
  },
)

export const selectAlertBarPushdown = createSelector(
  [selectIsCspAuthenticatedFromState],
  (isCspAuthenticated) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    return pushDown
  },
)

export const selectForbiddenPushdown = createSelector(
  [selectIsCspAuthenticatedFromState, selectIsAlertBarOpenFromState],
  (isCspAuthenticated, isAlertBarOpen) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    if (isAlertBarOpen) {
      pushDown += 40
    }
    return pushDown
  },
)

export const selectFailPushdown = createSelector(
  [
    selectIsCspAuthenticatedFromState,
    selectIsAlertBarOpenFromState,
    selectUserHasForbiddenScreening,
  ],
  (isCspAuthenticated, isAlertBarOpen, userHasForbiddenScreening) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    if (isAlertBarOpen) {
      pushDown += 40
    }
    if (userHasForbiddenScreening) {
      pushDown += 40
    }
    return pushDown
  },
)

export const selectDowngradePushdown = createSelector(
  [
    selectIsCspAuthenticatedFromState,
    selectIsAlertBarOpenFromState,
    selectUserHasForbiddenScreening,
    selectUserHasFailScreening,
  ],
  (
    isCspAuthenticated,
    isAlertBarOpen,
    userHasForbiddenScreening,
    userHasFailScreening,
  ) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    if (isAlertBarOpen) {
      pushDown += 40
    }
    if (userHasForbiddenScreening) {
      pushDown += 40
    }
    if (userHasFailScreening) {
      pushDown += 40
    }
    return pushDown
  },
)

export const selectAcknowledgementPushdown = createSelector(
  [
    selectIsCspAuthenticatedFromState,
    selectIsAlertBarOpenFromState,
    selectUserHasForbiddenScreening,
    selectUserHasFailScreening,
  ],
  (
    isCspAuthenticated,
    isAlertBarOpen,
    userHasForbiddenScreening,
    userHasFailScreening,
  ) => {
    let pushDown = 0
    if (isCspAuthenticated) {
      pushDown += 64
    }
    if (isAlertBarOpen) {
      pushDown += 40
    }
    if (userHasForbiddenScreening) {
      pushDown += 40
    }
    if (userHasFailScreening) {
      pushDown += 40
    }
    return pushDown
  },
)
